<div class="container-fluid p-h-0 p-v-20 h-100 bg" style="background-image: url('assets/images/others/login-3.png')">
    <div class="d-flex flex-column justify-content-between h-100">
        <div class="d-none d-md-block"></div>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-7 col-lg-5 m-h-auto">
                    <nz-card class="m-b-100 shadow-lg">
                        <div class="d-flex align-items-center justify-content-between m-b-30">
                            <img class="img-fluid" alt="" src="assets/images/logo/logo.png">
                            <h2 class="m-b-0">Sign In</h2>
                        </div>
                        <form nz-form [formGroup]="loginForm" nzLayout="vertical" class="login-form" (ngSubmit)="submitForm()">
                            <nz-form-item>
                                <nz-form-label  nzRequired nzFor="userName">Email</nz-form-label>
                                <nz-form-control nzErrorTip="Please input your Email!">
                                    <nz-input-group [nzPrefix]="prefixUser">
                                        <input type="email" nz-input formControlName="userName" placeholder="Username" (input)="isError = false">
                                    </nz-input-group>
                                </nz-form-control>
                            </nz-form-item>
                            <nz-form-item class="relative">
                                <nz-form-label nzRequired nzFor="password">Password</nz-form-label>
                                <nz-form-control nzErrorTip="Please input your Password!">
                                    <nz-input-group [nzPrefix]="prefixLock">
                                        <input type="password" nz-input formControlName="password" placeholder="Password" (input)="isError = false">
                                    </nz-input-group>
                                </nz-form-control>
                                <a class="float-right font-size-13 text-muted" style="position:absolute; right: 0" [routerLink]="['/reset-password']">Forget Password?</a>
                            </nz-form-item>
                            <p class="text-danger" *ngIf="isError">Invalid Email or Password</p>
                            <p class="text-danger" *ngIf="isBlocked">The user has been blocked. Please contact the administrator</p>
                            <nz-form-item>
                                <nz-form-control>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <span class="font-size-13 text-muted"></span>
                                        <button nz-button class="login-form-button" [nzType]="'primary'" >Sign In</button>
                                    </div>
                                </nz-form-control>
                            </nz-form-item>
                        </form>
                        <ng-template #prefixUser><i nz-icon nzType="user"></i></ng-template>
                        <ng-template #prefixLock><i nz-icon nzType="lock"></i></ng-template>
                    </nz-card>
                </div>
            </div>
        </div>
        <div class="d-none d-md-flex p-h-40 justify-content-between">
            <span class="">Copyright © 2024 Innovative Tax Relief. All rights reserved.</span>
        </div>
    </div>
</div>